import { memo, useMemo } from "react";

import { Icon } from "@atoms/icon";

import { getIconSize } from "./helper";
import classes from "./styles.module.scss";
import {
  IProductKeyIconsColorEnum,
  IProductKeyIconsSizeEnum,
  IProductKeyIconsVariantsEnum,
} from "./types";

import type { IProductKeyIconsProps } from "./types";

export const ProductKeyIcons = memo(function ProductKeyIcons(
  props: IProductKeyIconsProps,
) {
  const {
    iconName,
    color = IProductKeyIconsColorEnum.Primary,
    size = IProductKeyIconsSizeEnum.XXLarge,
    variant = IProductKeyIconsVariantsEnum.Stroke,
    disabled,
  } = props;

  const iconSize = useMemo(() => getIconSize(size), [size]);

  return (
    <div
      data-variant={variant}
      data-color={color}
      data-size={size}
      className={classes.productKeyIcon}
      data-disabled={disabled}
    >
      <Icon name={iconName} fontSize={iconSize} />
    </div>
  );
});
ProductKeyIcons.displayName = "ProductKeyIcons";
